import { render, staticRenderFns } from "./A3Posters.vue?vue&type=template&id=ea865b70"
import script from "./A3Posters.vue?vue&type=script&lang=js"
export * from "./A3Posters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports